export default class SubscriptionUsageRecordViewModel {
  constructor(data) {
    this.id = data.id;
    this.organizationId = data.organizationId;
    this.subscriptionPeriodKey = data.subscriptionPeriodKey;
    this.assetId = data.assetId;
    this.scanId = data.scanId;
    this.scanName = data.scanName;
    this.sourceFileName = data.sourceFileName;
    this.videoLengthSeconds = data.videoLengthSeconds ?? 0;
    this.minutesCharged = data.minutesCharged ?? 0;
    this.status = data.status;
    this.refundedOn = data.refundedOn;
    this.createdOn = data.createdOn;
  }

  get displayName() {
    return this.scanName || this.sourceFileName || this.scanId || '(unknown scan)';
  }

  // mm:ss formatting for raw duration.
  get durationLabel() {
    const total = Math.max(0, Math.round(this.videoLengthSeconds));
    const mm = Math.floor(total / 60);
    const ss = (total % 60).toString().padStart(2, '0');
    return `${mm}:${ss}`;
  }

  // mdi icon name driven by source file extension. No thumbnails for v1.
  get fileTypeIcon() {
    const ext = (this.sourceFileName || '').split('.').pop()?.toLowerCase();
    if (ext === 'insv') return 'mdi-rotate-3d-variant';
    if (ext === 'mov') return 'mdi-video-box';
    if (ext === 'mp4') return 'mdi-video-outline';
    return 'mdi-file-video-outline';
  }
}
